<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import Table from '@components/newtable'
import { ADMIN_ROLE } from '@utils/constant'
import { ErrorWrapper } from '@utils/error-handler'
import {
  blogComputed,
  blogListMethod,
  authComputed,
  collegeComputed,
  collegeListMethod,
  siteListMethod,
} from '@state/helpers'

export default {
  page: {
    title: 'Blog List',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { Layout, Table },
  data() {
    return {
      ADMIN_ROLE: ADMIN_ROLE,
      isLoading: true,
      bloglist: {},
      allBlogList: {},
      collegelist: [],
      collegeId: 'All',
      platformId: 'All',
      isUserAdmin: false,
      siteconfiglist: [],
      allCollegeList: [],
      fields: [
        {
          value: 'title',
          text: 'Title',
          sortable: true,
          colType: 'default',
        },
        {
          value: 'category.name',
          text: 'Category',
          sortable: true,
          colType: 'default',
        },
        { value: 'tags', text: 'Tags', sortable: true, colType: 'default' },
        {
          value: 'action',
          text: 'Action(s)',
          sortable: false,
          colType: 'button',
        },
      ],
      displayFields: [
        { key: 'title', label: 'Title', colType: 'default' },
        { key: 'tags', label: 'Tags', colType: 'list' },
        { key: 'category', label: 'Category', colType: 'default' },
        { key: 'description', label: 'Description', colType: 'html' },
        { key: 'createdAt', label: 'Created On', colType: 'date' },
      ],
    }
  },
  computed: {
    ...blogComputed,
    ...authComputed,
    ...collegeComputed,
  },
  mounted() {
    this.getListOfPlatform()
    this.getListOfBlogs()
    this.getColleges()
  },
  methods: {
    ...blogListMethod,
    ...collegeListMethod,
    ...siteListMethod,
    // get list of platform
    getListOfPlatform() {
      this.fetchSiteList()
        .then((siteconfig) => {
          var listitems = []
          listitems.push({ value: 'All', text: 'All' })
          siteconfig.forEach((element) => {
            var ele = {}
            ele.text = element.site_name
            ele.value = element.platform_id
            listitems.push(ele)
          })
          this.siteconfiglist = listitems
        })
        .catch((_error) => {})
    },

    getColleges() {
      const filter = {
        page: this.$route.query.page ? this.$route.query.page : 1,
        limit: 100,
        sort: 'sort_order',
        order: '-1',
      }
      this.fetchCollegeList({ filter })
        .then((college) => {
          var listitems = []
          listitems.push({ value: 'All', text: 'All' })
          college.docs.forEach((element) => {
            var ele = {}
            ele.text = element.name
            ele.value = element._id
            ele.platform_id = element.platform_id
            listitems.push(ele)
          })
          this.collegelist = listitems
          this.allCollegeList = listitems
        })
        .catch((_error) => {})
    },

    getBlogs() {
      if (this.collegeId !== 'All') {
        let listitems = []
        this.allBlogList.docs.forEach((element) => {
          if (element.college_id === this.collegeId) {
            listitems.push(element)
          }
        })
        this.bloglist.docs = listitems
      } else {
        if (this.role !== 'admin') {
          this.bloglist.docs = this.allBlogList.docs
        } else {
          let listitems = []
          this.allBlogList.docs.forEach((element) => {
            if (element.platform_id === this.platformId) {
              listitems.push(element)
            }
          })
          this.bloglist.docs = listitems
        }
      }
    },

    getPlatformColleges() {
      this.collegeId = 'All'
      this.isUserAdmin = true
      let listitems = []
      listitems.push({ value: 'All', text: 'All' })
      this.allCollegeList.forEach((element) => {
        if (element.platform_id === Number(this.platformId)) {
          listitems.push(element)
        }
      })
      this.collegelist = listitems
      if (this.platformId !== 'All') {
        let listitems = []
        this.allBlogList.docs.forEach((element) => {
          if (element.platform_id.includes(Number(this.platformId))) {
            listitems.push(element)
          }
        })
        this.bloglist.docs = listitems
      } else {
        this.bloglist.docs = this.allBlogList.docs
      }
    },

    // Get list of all blogs role wise
    getListOfBlogs() {
      const filter = {
        page: this.$route.query.page ? this.$route.query.page : 1,
        limit: 10,
        sort: 'sort_order',
        order: '-1',
      }
      this.fetchBlogList({ filter })
        .then((blogList) => {
          this.bloglist = JSON.parse(JSON.stringify(blogList))
          this.allBlogList = JSON.parse(JSON.stringify(blogList))
          this.isLoading = false
        })
        .catch((error) => {
          this.isLoading = false
          this.tryingToLogIn = false
          var getError = new ErrorWrapper(error)
          this.authError = getError.message
          this.isAuthError = true
        })
    },
  },
}
</script>

<template>
  <Layout>
    <div class="row">
      <div class="col-md-12">
        <b-overlay :show="isLoading" :opacity="0.6" rounded="sm">
          <b-card>
            <router-link tag="button" to="/blog-add" class="btn btn-info mb-2">
              <i class="ti-plus"></i><span> Add Blog</span> </router-link
            ><br />
            <b-form-group
              v-if="role === 'admin'"
              label="Select Platform"
              label-for="input-1"
            >
              <b-form-select
                v-model="platformId"
                :options="siteconfiglist"
                style="width: 50%"
                @change="getPlatformColleges"
              ></b-form-select>
            </b-form-group>
            <b-form-group
              v-if="
                (role === 'admin' && isUserAdmin) || role === 'administrator'
              "
              label="Select College"
              label-for="input-1"
            >
              <b-form-select
                v-model="collegeId"
                :options="collegelist"
                style="width: 50%"
                @change="getBlogs"
              ></b-form-select>
            </b-form-group>
            <Table
              :items="bloglist.docs ? bloglist.docs : []"
              :fields="fields"
              :bordered="true"
              :viewbtn="true"
              :deletebtn="true"
              :editbtn="true"
              :blog="true"
              :display-fields="displayFields"
            ></Table>
          </b-card>
        </b-overlay>
      </div>
    </div>
  </Layout>
</template>
